document.addEventListener('DOMContentLoaded', () => {
  // Add spacing to the body to prevent content from being hidden behind the sticky bar
  const stickyBar = document.getElementById('shopify-section-sticky-bottom-bar');
  if (stickyBar) {
    const stickyBarHeight = stickyBar.offsetHeight;
    document.body.style.paddingBottom = stickyBarHeight + 'px';
    
    // Hide the bar when scrolling down, show when scrolling up - except at bottom of page
    let lastScrollY = window.scrollY;
    
    window.addEventListener('scroll', function() {
      const currentScrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Check if we're near the bottom of the page (within 50px)
      const isNearBottom = currentScrollY + windowHeight >= documentHeight - 50;
      
      if (currentScrollY > lastScrollY && currentScrollY > 150 && !isNearBottom) {
        // Scrolling down & past threshold & not at bottom
        stickyBar.classList.add('hide');
      } else {
        // Scrolling up or at top or at bottom
        stickyBar.classList.remove('hide');
      }
      lastScrollY = currentScrollY;
    });
    
    // Adjust padding on window resize
    window.addEventListener('resize', function() {
      const updatedHeight = stickyBar.offsetHeight;
      document.body.style.paddingBottom = updatedHeight + 'px';
      
      // Apply mobile padding if needed
      if (window.innerWidth <= 767) {
        stickyBar.style.padding = '{{ section.settings.mobile_padding_vertical }}px {{ section.settings.mobile_padding_horizontal }}px';
      } else {
        stickyBar.style.padding = '{{ section.settings.desktop_padding_vertical }}px {{ section.settings.desktop_padding_horizontal }}px';
      }
    });
    
    // Set initial mobile padding if needed
    if (window.innerWidth <= 767) {
      stickyBar.style.padding = '{{ section.settings.mobile_padding_vertical }}px {{ section.settings.mobile_padding_horizontal }}px';
    }
  }
});